import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/common/hooks/useAuth';
import FullLoading from '@/components/common/FullLoading';
import URL from '@/common/routes/Url';

type Props = {
  children?: React.ReactNode;
};

const Guard: React.FC<Props> = ({ children }) => {
  const { auth, user } = useAuth();
  const location = useLocation();

  const authed = user && Object.keys(user).length !== 0;

  useLayoutEffect(() => {
    (async () => {
      const result = await auth();
      if (!result) {
        // window.location.href = URL.signin;
        window.location.href = URL.homePage;
      }
    })();
  }, [location]);

  return authed ? <>{children}</> : <FullLoading />;
};

export default Guard;
